import { Trip } from "domain/entities/trip";
import { create } from "zustand";
import { devtools } from "zustand/middleware";

interface TripState {
  trip: (Trip & { locationOrigin?: string })[] ;
  setTrip: (newTrip: (Trip & { locationOrigin?: string })[]) => void;
}

const initialTripState: Trip[] = [];

export const useTripStore = create<TripState>()(
  devtools(
    (set) => ({
      trip: initialTripState,
      setTrip: (newTrips) => set(() => ({ trip: newTrips })),
      resetTrip: () => set({ trip: [] }),
    }),
    { name: "TripSelected" }
  )
);
